import styled from 'styled-components';
import { colorFillTertiary, colorNeutral } from '@atlas-frontend/design-tokens';

export const ContextMenuItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 7px 8px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
  color: ${colorNeutral};

  &:hover {
    background: ${colorFillTertiary};
  }
`;
